import { render, staticRenderFns } from "./FuncForm.vue?vue&type=template&id=30a6875c"
import script from "./FuncForm.vue?vue&type=script&lang=js"
export * from "./FuncForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports